import {
  genericRequiredFieldError,
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';

const {
  formField: { principalType, principalTrustName },
} = loanFormModel;

export class PrincipalTrustNameValidation implements ValidationSchema {
  public name = principalTrustName.name;
  public label = principalTrustName.label;
  public dependsOn: string[] = [principalType.name, 'relationship'];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalType: string, principalRelationship: string, schema) {
    if (
      principalType === RELATED_PARTY_TYPES.ENTITY &&
      principalRelationship !== RELATED_PARTY_RELATIONSHIP.LANDLORD
    ) {
      return schema.required(genericRequiredFieldError);
    }
    return schema.notRequired();
  }
}
export default new Validation(new PrincipalTrustNameValidation());
